import { ApiClientProvider, useTheme } from "@homesite/hooks";
import { ThemeProvider } from "@homesite/ui";
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useState } from "react";
import { apiClient } from "./lib/apiClient";
import { createQueryClient } from "./lib/queryClient";

export function Providers({ children }: { children: ReactNode }): ReactNode {
	const [queryClient] = useState<QueryClient>(() => createQueryClient());
	return (
		<QueryClientProvider client={queryClient}>
			<ApiClientProvider client={apiClient}>
				<ThemedShell>{children}</ThemedShell>
			</ApiClientProvider>
		</QueryClientProvider>
	);
}

function ThemedShell({ children }: { children: ReactNode }): ReactNode {
	const { theme, setTheme } = useTheme();
	return (
		<ThemeProvider theme={theme} onThemeChange={setTheme}>
			{children}
		</ThemeProvider>
	);
}
